export type ThemeUrlKeys =
  | ''
  | 'Vanilla'
  | 'Ziploc'
  | 'Off'
  | 'Autan'
  | 'OffDefense'
  | 'AutanDefense'
  | 'Corporate'
  | 'Glade'
  | 'Raid'
  | 'Baygon'
  | 'Duck'
  | 'Pyrel'
  | 'MrMuscle'
  | 'Pledge'
  | 'Lysoform'
  | 'Drano'
  | 'PIDS'
  | 'Windex'
  | 'Exposis'
  | 'ScrubbingBubbles'
  | 'WISCJ'
  | 'Global'
  | 'Shout'
  | 'Fantastik';

export const ThemeUrls: Record<ThemeUrlKeys, string> = {
  // Fallback condition
  '': 'https://cdn.fonts.net/kit/fbf8b1ba-7fcf-4b12-9d7e-e861055df2df/fbf8b1ba-7fcf-4b12-9d7e-e861055df2df_enhanced.css',
  Vanilla:
    'https://cdn.fonts.net/kit/fbf8b1ba-7fcf-4b12-9d7e-e861055df2df/fbf8b1ba-7fcf-4b12-9d7e-e861055df2df_enhanced.css',
  Ziploc:
    'https://cdn.fonts.net/kit/fbf8b1ba-7fcf-4b12-9d7e-e861055df2df/fbf8b1ba-7fcf-4b12-9d7e-e861055df2df_enhanced.css',
  Off: 'https://cdn.fonts.net/kit/6d2a5c69-57ca-45e7-8356-aab2b89de362/6d2a5c69-57ca-45e7-8356-aab2b89de362_enhanced.css',
  Autan:
    'https://cdn.fonts.net/kit/91bafb19-dd0d-46c3-b974-1b784ef8b8a4/91bafb19-dd0d-46c3-b974-1b784ef8b8a4_enhanced.css',
  OffDefense:
    'https://cdn.fonts.net/kit/7b70addb-0752-4a94-9df7-fc4cc06962b6/7b70addb-0752-4a94-9df7-fc4cc06962b6_enhanced.css',
  AutanDefense:
    'https://cdn.fonts.net/kit/57d1c822-88b2-4632-a4e3-1ed52891339f/57d1c822-88b2-4632-a4e3-1ed52891339f_enhanced.css',
  Corporate:
    'https://cdn.fonts.net/kit/3bcec18a-4ec4-4df8-a1ad-ea8283708578/3bcec18a-4ec4-4df8-a1ad-ea8283708578_enhanced.css',
  Glade:
    'https://cdn.fonts.net/kit/8383a640-2a23-4e11-96df-b4aab8fef5c9/8383a640-2a23-4e11-96df-b4aab8fef5c9_enhanced.css',
  Raid: 'https://cdn.fonts.net/kit/1bc50b91-f666-4197-8156-a77766f3e932/1bc50b91-f666-4197-8156-a77766f3e932_enhanced.css',
  Baygon:
    'https://cdn.fonts.net/kit/56b095f6-a989-4555-bade-03bf167c884e/56b095f6-a989-4555-bade-03bf167c884e_enhanced.css',
  Duck: 'https://cdn.fonts.net/kit/011c3eed-1d66-4d45-a5ba-85a7570b0ede/011c3eed-1d66-4d45-a5ba-85a7570b0ede_enhanced.css',
  Pyrel:
    'https://cdn.fonts.net/kit/d3652129-483b-4c81-b091-b958d3687c75/d3652129-483b-4c81-b091-b958d3687c75_enhanced.css',
  MrMuscle:
    'https://cdn.fonts.net/kit/190fdb61-4f30-4d13-a04a-bc3147e32196/190fdb61-4f30-4d13-a04a-bc3147e32196_enhanced.css',
  Pledge:
    'https://cdn.fonts.net/kit/078854c6-51e3-4501-b292-c1f3408dbec7/078854c6-51e3-4501-b292-c1f3408dbec7_enhanced.css',
  Lysoform:
    'https://cdn.fonts.net/kit/26b9ae77-6b51-459d-8909-89e079e65afd/26b9ae77-6b51-459d-8909-89e079e65afd_enhanced.css',
  Drano:
    'https://cdn.fonts.net/kit/8f1db52a-6cd8-40b7-8ec3-0e8aa3284392/8f1db52a-6cd8-40b7-8ec3-0e8aa3284392_enhanced.css',
  PIDS: 'https://cdn.fonts.net/kit/3bcec18a-4ec4-4df8-a1ad-ea8283708578/3bcec18a-4ec4-4df8-a1ad-ea8283708578_enhanced.css',
  Windex:
    'https://cdn.fonts.net/kit/a0ec0ac4-0fe4-4272-ae05-deafb57197ae/a0ec0ac4-0fe4-4272-ae05-deafb57197ae_enhanced.css',
  Exposis:
    'https://cdn.fonts.net/kit/7f221951-a26d-45b1-b1bf-f4ff20799546/7f221951-a26d-45b1-b1bf-f4ff20799546_enhanced.css',
  ScrubbingBubbles:
    'https://cdn.fonts.net/kit/7da8ecf7-da6c-4244-b789-8a9b5c2c873d/7da8ecf7-da6c-4244-b789-8a9b5c2c873d_enhanced.css',
  WISCJ:
    'https://cdn.fonts.net/kit/3bcec18a-4ec4-4df8-a1ad-ea8283708578/3bcec18a-4ec4-4df8-a1ad-ea8283708578_enhanced.css',
  Global:
    'https://cdn.fonts.net/kit/25ca3146-485f-4b3b-a344-805fbb516663/25ca3146-485f-4b3b-a344-805fbb516663_enhanced.css',
  Fantastik:
    'https://cdn.fonts.net/kit/7da8ecf7-da6c-4244-b789-8a9b5c2c873d/7da8ecf7-da6c-4244-b789-8a9b5c2c873d_enhanced.css',
  Shout:
    'https://cdn.fonts.net/kit/1cbc7839-e4c9-478d-b63f-d356770b00b3/1cbc7839-e4c9-478d-b63f-d356770b00b3_enhanced.css',
};
